// import "babel-polyfill";
// Es6Promise.polyfill();
// import "fetch-detector";
// import "fetch-ie8";
// import "./registerServiceWorker";

import Vue from "vue";
import App from "./App.vue";
import router, { needCacheRoutes } from "./router";
import store from "./store";
// import { provide } from "@/plugins/apollo";
import i18n from "@/plugins/i18n";
import "@/plugins/vant";
import "@/plugins/directive";
import "@/plugins/components";
import "./assets/css/common.less";
import "@/components/common/GtLoading/index";
import "@/plugins/sentry";
import "@/plugins/router/RouterTransition";
import "@/plugins/fullpage";

// 设置缓存路由
store.commit("app/setCacheRoutesMutation", needCacheRoutes);

Vue.config.productionTip = false;

// process.env.NODE_ENV !== "development" &&

// import vconsole from "vconsole";
// new vconsole();

// import FastClick from "fastclick";
// FastClick.attach(document.body);

// 全局filter
Vue.filter("$", function (value = 0) {
  const currency = process.env.currency;
  const currencySeparator = process.env.currencySeparator;
  let fixedNum = Number(process.env.toFixed);
  let basicNum = fixedNum ? Math.pow(10, fixedNum) : 1;
  let filterValue = (
    Math.floor(Number(value) * basicNum) / basicNum
  ).toString();

  return (
    currency +
      " " +
      filterValue.replace(
        /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
        `$&${currencySeparator}`
      ) || ""
  );
});

new Vue({
  router,
  store,
  // provide,
  i18n,
  render: h => h(App)
}).$mount("#app");
